<template>
  <div class="nav-item" :class="name != 'Dashboard' ? 'nav-item-margin' : ''" align="center">
    <router-link :to="url" class="nav-link" v-if="this.name != 'New Event'">
      <Icon :name="icon" class="icon-size"></Icon>
      <div class="wrapper-notify-number" v-if="notifyNumber > 0">
        <span class="fa-stack" :class="renderClass" :data-count="notifyNumber">
        </span>
      </div>
      <br/>
      <div :class="(eventStatus == 'review' || eventStatus == 'submitted') ? 'text-section' : null">
        <span v-if="eventStatus !== 'review' && eventStatus !== 'submitted'" class="nav-font-size-big">{{name}}</span>
        <span v-if="eventStatus === 'review'" class="nav-font-size-small">{{name}}</span>
        <span v-if="eventStatus === 'submitted'" class="nav-font-size-small">{{name}}</span><br />
        <div class="nav-font-size-big" v-if="eventStatus === 'submitted'">ADURO</div>
        <div class="nav-font-size-big nav-ellipsis" v-if="eventStatus === 'review'">{{getClientName}}</div>
      </div>
    </router-link>
    <div class="nav-item" v-else @click="newEventClick()">
      <div class="nav-link">
        <Icon :name="icon" class="icon-size"></Icon>
        <div class="wrapper-notify-number" v-if="notifyNumber > 0">
          <span class="fa-stack" :class="renderClass" :data-count="notifyNumber">
          </span>
        </div>
        <br/>
        <span v-if="eventStatus !== 'review' && eventStatus !== 'submitted'" class="nav-font-size-big">{{name}}</span>
        <span v-if="eventStatus === 'review'" class="nav-font-size-small">{{name}}</span>
        <span v-if="eventStatus === 'submitted'" class="nav-font-size-small">{{name}}</span><br />
        <span v-if="eventStatus === 'submitted'" class="nav-font-size-big">ADURO</span>
        <span class="nav-font-size-big" v-if="eventStatus === 'review'">{{getClientName}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-awesome/icons/area-chart';
import 'vue-awesome/icons/plus-circle';
import 'vue-awesome/icons/file-text-o';
import 'vue-awesome/icons/calendar-check-o';
import 'vue-awesome/icons/inbox';
import 'vue-awesome/icons/eye';
import 'vue-awesome/icons/archive';
import 'vue-awesome/icons/trash';

import Icon from 'vue-awesome/components/Icon';
import constants from '../../_consts'
import {mapGetters, mapActions} from 'vuex';

export default {
  components: {
    Icon
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    notifyNumber: {
      type: Number,
      default: 0
    },
    eventStatus: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      class1: 'small-notify-number',
      class2: 'big-notify-number',
      class3: 'sidebar-item-new-event'
    };
  },
  computed: {
    renderClass () {
      return this.notifyNumber < 10 ? this.class1 : this.class2;
    },
    renderCssItemNewEvent () {
      if (this.name === 'New Event') {
        return this.class3;
      }
    },
    ...mapGetters({
      getClientName: 'GETTERS_GET_CLIENT_NAME'
    })
  },
  methods: {
    ...mapActions({
      btnCreateNewEventOnSideBar: 'CREATE_EVENT_FLAG'
    }),
    newEventClick () {
      this.btnCreateNewEventOnSideBar(true).then(() => {
        this.$router.replace(constants.routeDirect.userDrafts);
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@/styles/variables.less';

.nav-item {
  height: 70px;
  position: relative;
  .nav-link {
    height: 70px;
    padding: 0px 0 0 0 !important;
    .text-section{
      margin-top: -5px;
    }
    .nav-ellipsis {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 100px;
    }
  }
  .active{
    .nav-font-size-small{
      color: @black;
    }
    .nav-font-size-big{
      color: @black;
    }
  }
}

.wrapper-notify-number {
  width: 17px;
  height: 17px;
  background: @white;
  border-color: @dark-blue-1;
  border-radius: 8px;
  text-align: center;
  position: absolute;
  top: 0%;
  right: 34%;
  border: 0.5px solid @dark-blue-1;
  margin-top: 5px;
}

.fa-stack[data-count]:after {
  content: attr(data-count);
  font-size: 9px;
  line-height: .75em;
  color: @bg-grey;
  text-align: center; // font-weight: bold;
  top: 5px;
  color: @dark-blue-1;
  position: absolute;
}

.fa-stack::after {
  align-content: center;
}

.small-notify-number::after {
  left: 5px;
}

.big-notify-number::after {
  left: 3px;
}

.icon-size {
  height: 26px;
  width: 26px;
  // font-size: 26px;
  // line-height: 26px;
  margin: 0px 0 0 0;
}

.nav-font-size-big {
  font-size: 12px;
  margin-top: -6px;
}

.nav-font-size-small {
  font-size: 10px;
  height: 14px;
  width: 76px;
  font-family: @font-family-main;
  line-height: 14px;
  text-align: center;
}


.sidebar .nav .nav-item .nav-link [class^="icon-"]{
  margin-top: 13px;
}

.sidebar .nav .nav-item .nav-link {
  width: 112px;
  border-left: 5px solid @dark-blue;
  &:hover{
    border-left: 5px solid #20a8d8;
  }
}

.sidebar .nav .nav-item .nav-link.active{
  border-left: 5px solid #0080A5;
}
.sidebar .nav .nav-item .nav-item-margin{
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// SidebarNavIcons.vue?77347ef4